<template>
  <div class="banner-box" @mouseover="boxMouseOver" @mouseout="boxMouseOut">
    <div class="banner-container" ref="container">
      <div class="banner-movebg" :style="{ backgroundImage: 'url('+ bannerData.bgUrl +')', height: bannerLength * 100 + '%' }"></div>
      <div class="banner-wrapper">
        <div class="banner-slide" v-for="(banner, index) in bannerData.banners" :key="index">
          <a :href="banner.src" :target="banner.target" style="display: block" :style="{cursor: banner.type != 0 ? 'pointer' : 'default'}">
            <div class="animate-wrapper">
              <div class="animated animate-item" v-for="(item, index) in banner.imgs" :style="{left: item.left+'px', top: item.top+'px'}" :key="index">
                <!-- <a :href="item.href" :target="item.target" style="display: block" :style="{cursor: item.type != 0 ? 'auto' : 'default'}"><img :src="item.imgUrl" alt=""></a> -->
                <a v-if="item.type != 0" :href="item.src" :target="item.target" style="display: block"><img :src="item.url" alt=""></a>
                <div v-else><img :src="item.url" alt=""></div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div class="banner-pagination banner-pagination-bullets" v-if="bannerLength > 1">
      <span class="banner-pagination-bullet" :class="{'banner-pagination-bullet-active': activeIndex === index}" v-for="(item, index) in bannerLength" @click="slideTo(index)" :key="index"></span>
    </div>
    <div class="banner-button-prev" @click="slidePrev" v-if="bannerLength > 1"></div>
    <div class="banner-button-next" @click="slideNext" v-if="bannerLength > 1"></div>
  </div>
</template>
<script type="text/javascript">
import $ from '../../../static/js/jquery.min.js'
import '../../../static/js/jquery-smart3d.js'
// import bannerData from './bannerdata.js'
export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    duration: {
      type: Number,
      default: 5000
    }
  },
  data () {
    return {
      // data: bannerData,
      bannerData: {},
      activeIndex: 0,
      oldIndex: 0,
      transform: '',
      animationName: '',
      $container: null,
      $slides: null,
      slideLength: 0,
      timer: null,
      timeout: null,
      isLock: false,
      vendor: false,
      timerList: []
    }
  },
  computed: {
    bannerLength () {
      return this.bannerData.banners ? this.bannerData.banners.length : 0
    }
  },
  watch: {
    data () {
      this.bannerData = Object.assign({}, this.handleData())
      this.$nextTick(() => {
        this.$container = this.$refs.container
        this.$slides = $('.banner-slide', this.$container)
        this.slideLength = this.$slides.length
        this.vender = this.calcVendor()
        this.initBanner()
      })
    }
  },
  created () {
    this.activeIndex = 0
    this.transform = this.prefixStyle('transform')
    this.animationName = this.prefixStyle('animationName')
    this.oldIndex = this.activeIndex
    // this.bannerData = bannerData
    // this.handleData()
  },
  beforeDestroy () {
    clearInterval(this.timer)
    clearInterval(this.timeout)
    this.timerList.forEach((item) => {
      item.destroy()
    })
  },
  methods: {
    initBanner () {
      // this.$slides.css({
      //   'zIndex': 1
      // }).eq(this.activeIndex).css({
      //   'zIndex': 9
      // }).find('.animated').css({
      //   animationName: 'fadeInUp'
      // })
      this.$slides.css({
        'zIndex': 1
      }).eq(this.activeIndex).css({
        'zIndex': 9
      }).find('.animated').removeClass('fadeOutDown fadeInUp').addClass('fadeInUp')

      this.$slides.eq(this.activeIndex).stop().animate({
        'opacity': 1
      }, 700).siblings().stop().animate({
        'opacity': 0
      }, 700)

      this.autoPlay()
      $('.animate-wrapper').each((index, item) => {
        let smart3d = $(item).smart3d({
          invertHorizontal: true,
          invertVertical: true
          // last_is_static: true,
          // first_is_static: true
        })
        this.timerList.push(smart3d)
      })
    },
    handleData () {
      let data = Object.assign({}, this.data)
      data.bgMoveDistance = data.bgMoveDistance || 300
      data.banners = data.banners.map((item, index) => {
        if (item.type - 0 === 1) { // 本页跳转
          item.target = ''
        } else if (item.type - 0 === 2) { // 新页跳转
          item.target = '_blank'
        } else { // 不跳转
          item.src = 'javascript:;'
          item.target = ''
        }
        item.imgs = item.imgs.map((item, index) => {
          if (item.type - 0 === 1) { // 本页跳转
            item.target = ''
          } else if (item.type - 0 === 2) { // 新页跳转
            item.target = '_blank'
          } else { // 不跳转
            item.src = 'javascript:;'
            item.target = ''
          }
          return item
        })
        return item
      })
      data.banners = data.banners.filter((item) => {
        if (item.imgs.length === 0) {
          return false
        }
        return true
      })
      return data
    },
    boxMouseOver () {
      clearInterval(this.timer)
    },
    boxMouseOut () {
      this.autoPlay()
    },
    calcVendor () {
      let elementStyle = document.createElement('div').style
      let transformNames = {
        webkit: 'webkitTransform',
        Moz: 'MozTransform',
        O: 'OTransform',
        ms: 'msTransform',
        standard: 'transform'
      }
      for (let key in transformNames) {
        if (elementStyle[transformNames[key]] !== undefined) {
          return key
        }
      }
      return false
    },
    autoPlay () {
      if (this.bannerLength <= 1) {
        return
      }
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.slideNext()
      }, this.duration)
    },
    slidePrev () {
      if (this.isLock) {
        return
      }
      this.isLock = true
      // clearInterval(this.timer)
      this.activeIndex = this.activeIndex - 1 < 0 ? this.slideLength - 1 : this.activeIndex - 1

      // 先做离场动画
      let nextIndex = this.activeIndex + 1 === this.slideLength ? 0 : this.activeIndex + 1
      this.$slides.eq(nextIndex).each((index, item) => {
        // $(item).animate({
        //   'opacity': 0
        // }, 700)
        // $(item).find('.animated').css({
        //   animationName: 'fadeOutDown'
        // })
        $(item).find('.animated').removeClass('fadeOutDown fadeInUp').addClass('fadeOutDown')
      })
      this.play()

      // setTimeout(() => {
      //   this.autoPlay()
      // }, 1000)
    },
    slideNext () {
      if (this.isLock) {
        return
      }
      this.isLock = true
      // clearInterval(this.timer)
      this.activeIndex = this.activeIndex + 1 === this.slideLength ? 0 : this.activeIndex + 1

      // 先做离场动画
      let prevIndex = this.activeIndex - 1 < 0 ? this.slideLength - 1 : this.activeIndex - 1
      this.$slides.eq(prevIndex).each((index, item) => {
        // $(item).animate({
        //   'opacity': 0
        // }, 700)
        // $(item).find('.animated').css({
        //   animationName: 'fadeOutDown'
        // })
        $(item).find('.animated').removeClass('fadeOutDown fadeInUp').addClass('fadeOutDown')
      })
      this.play()

      // setTimeout(() => {
      //   this.autoPlay()
      // }, 1000)
    },
    slideTo (index) {
      if (this.isLock) {
        return
      }
      this.isLock = true
      // clearInterval(this.timer)
      this.activeIndex = index
      // 先做离场动画
      this.$slides.eq(this.oldIndex).each((index, item) => {
        // $(item).animate({
        //   'opacity': 0
        // }, 700)
        // $(item).find('.animated').css({
        //   animationName: 'fadeOutDown'
        // })
        $(item).find('.animated').removeClass('fadeOutDown fadeInUp').addClass('fadeOutDown')
      })
      this.play()
    },
    play () {
      // 轮播开始
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.oldIndex = this.activeIndex
        $('.banner-pagination-bullet').eq(this.activeIndex).addClass('banner-pagination-bullet-active').siblings().removeClass('banner-pagination-bullet-active')
        // 入场动画
        this.$slides.eq(this.activeIndex).fadeIn().siblings().fadeOut()
        // this.$slides.css({
        //   'zIndex': 1
        // }).eq(this.activeIndex).css({
        //   'zIndex': 9
        // }).find('.animated').css({
        //   animationName: 'fadeInUp'
        // })
        this.$slides.css({
          'zIndex': 1
        }).eq(this.activeIndex).css({
          'zIndex': 9
        }).find('.animated').removeClass('fadeOutDown fadeInUp').addClass('fadeInUp')
        this.$slides.eq(this.activeIndex).stop().animate({
          'opacity': 1
        }, 700).siblings().stop().animate({
          'opacity': 0
        }, 700)
        $('.banner-movebg').css({
          transform: 'translate(0px, ' + this.bannerData.bgMoveDistance * this.activeIndex + 'px)'
        })
        setTimeout(() => {
          this.isLock = false
        }, 1200)
      }, 300)
    },
    prefixStyle (style) {
      if (this.vendor === false) {
        return false
      }
      if (this.vendor === 'standard') {
        return style
      }
      return this.vendor + style.charAt(0).toUpperCase() + style.substr(1)
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.banner-box
  position relative
  box-shadow rgba(35, 55, 73, 0.35) 0px 3px 18px 0px
  overflow hidden
  backface-visibility hidden

.banner-container
  width 100%
  height 300px
  overflow hidden
  position relative
  .banner-movebg
    background-repeat no-repeat
    background-size 100% auto
    background-position bottom center
    position absolute
    bottom 0
    width 100%
    min-height 100%
    -webkit-transition 700ms 350ms
    transition 700ms 350ms
  .banner-wrapper
    position relative
    height 300px
    overflow hidden
  .banner-slide
    top 0
    left 0
    width 100%
    height 300px
    line-height 100px
    text-align center
    font-size 30px
    position absolute
    opacity 0
    background rgba(255, 255, 255, 0)
    .animate-wrapper
      width 1140px
      height 300px
      margin 0 auto
      position relative
    .animate-item
      margin 0 auto
      position absolute
      animation-timing-function cubic-bezier(.48, -0.7, .38, 1.01)
      img
        display block
    .animated:nth-child(2n)
      animation-delay 0.05s
  .banner-slide:not(0)
    display none
/* 下面的导航 */

.banner-pagination
  position absolute
  text-align center
  transition 300ms opacity
  transform translate(0, 0)
  z-index 10
.banner-pagination-bullets
  bottom 10px
  left 0
  width 100%
  .banner-pagination-bullet
    width 70px
    margin 0 4px
    height 3px
    display inline-block
    background #000
    opacity .2
    cursor pointer
  .banner-pagination-bullet-active
    opacity 1
    background #007aff


/* 左右按钮 */

.banner-button-next, .banner-button-prev
  position absolute
  top 50%
  width 27px
  height 44px
  margin-top -22px
  z-index 10
  cursor pointer
  background-size 27px 44px
  background-position center
  background-repeat no-repeat

.banner-button-prev
  background-image url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23007aff'%2F%3E%3C%2Fsvg%3E")
  left 10px
  right auto

.banner-button-next
  background-image url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23007aff'%2F%3E%3C%2Fsvg%3E")
  right 10px
  left auto
/* 动画 */
.animated
  animation-duration 1s
  animation-fill-mode both
  &.fadeInUp
    animation-name fadeInUp
  &.fadeOutDown
    animation-name fadeOutDown

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate(0, 100%);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

@keyframes fadeOutDown {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate(0, 100%);
  }
}

</style>



// WEBPACK FOOTER //
// banner.vue?59f967d7